module.exports = __webpack_public_path__ + "img/icon3.723467eb.png";